export const BASE_API_URL = process.env.BASE_API_URL;

export const COOKIE_LOCALE = 'NEXT_LOCALE';
export const ACCESS_TOKEN = 'access_token';
